var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import nextId from 'react-id-generator';
import styles from './CopyToClipboardButton.module.scss';
import { FaLink } from 'react-icons/fa';
import { Tooltip } from 'devextreme-react';
import { CopyToClipBoardBlock } from '@app/Components/CopyToClipboardBlock/CopyToClipBoardBlock';
export var CopyToClipBoardButton = /** @class */ (function (_super) {
    __extends(CopyToClipBoardButton, _super);
    function CopyToClipBoardButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._copied = false;
        _this._isTooltipVisible = false;
        _this._id = nextId();
        return _this;
    }
    CopyToClipBoardButton.prototype.render = function () {
        var _a;
        var _this = this;
        var text = (_a = this.props, _a.text), copyText = _a.copyText;
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: "".concat(styles.iconWrapper) },
                React.createElement(CopyToClipBoardBlock, { text: text, onCopyHandler: function () { return (_this._copied = true); }, onMouseEnterHandler: function () { return (_this._isTooltipVisible = true); }, onMouseLeaveHandler: function () { return (_this._isTooltipVisible = false); } },
                    React.createElement(FaLink, { className: styles.icon, id: 'copy' + this._id }))),
            React.createElement(Tooltip, { position: "right", visible: this._isTooltipVisible, target: '#copy' + this._id }, this._copied ? 'Copied' : copyText !== null && copyText !== void 0 ? copyText : 'Copy to clipboard')));
    };
    __decorate([
        observable
    ], CopyToClipBoardButton.prototype, "_copied", void 0);
    __decorate([
        observable
    ], CopyToClipBoardButton.prototype, "_isTooltipVisible", void 0);
    CopyToClipBoardButton = __decorate([
        observer
    ], CopyToClipBoardButton);
    return CopyToClipBoardButton;
}(React.PureComponent));
